import React, { useMemo } from "react";
import { faCircleO } from "web-fortawesome/npm/pro-light";
import { faCircleO as faCircleOSolid } from "web-fortawesome/npm/pro-solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IPresenceIconProps } from "./IPresenceIconProps";

/**
 * Presence Icon: Contact Portal
 * @param props - props from interface IPresenceIconProps
 * @returns - the contact portal icon
 */
export const PresenceIconContactPortal = (props: IPresenceIconProps): React.ReactElement => {
	const icon = useMemo(() => {
		if (!props.callProtection && !props.lineForwarded) {
			if (props.type === "busy")
				return faCircleOSolid;
			else
				return faCircleO;
		}
		return faCircleO;
	}, [props.type, props.callProtection, props.lineForwarded]);

	return (
		<FontAwesomeIcon
			className={props.className}
			icon={icon}
			fontSize={props.fontSize ?? 16}
			color={props.color ? props.color : `var(--presence-icon-type-${props.type ?? "free"})`}
		/>
	);
};
